import { __assign, __rest } from "tslib";
import React from 'react';
import { Radio, RadioGroup, Stack, Text, VStack } from '@chakra-ui/react';
var RadioButtonsComponent = function (_a) {
    var label = _a.label, value = _a.value, onUpdateValue = _a.onUpdateValue, onChange = _a.onChange, defaultValue = _a.defaultValue, items = _a.items, props = __rest(_a, ["label", "value", "onUpdateValue", "onChange", "defaultValue", "items"]);
    return (React.createElement(VStack, { w: 'full', justifyContent: 'flex-start', alignItems: 'flex-start' },
        React.createElement(Text, null, label),
        React.createElement(RadioGroup, __assign({ onChange: function (val) {
                onUpdateValue && onUpdateValue(val);
                onChange && onChange(val);
            } }, props, { value: value, defaultValue: defaultValue }),
            React.createElement(Stack, { direction: 'row' }, items.map(function (item, index) { return (React.createElement(Radio, { key: index, value: item.value }, item.label)); })))));
};
export default RadioButtonsComponent;
//# sourceMappingURL=RadioButtonsComponent.js.map